export const MERCHANT_ADMIN_ACCOUNT = {
    CLICKABLE_LOGO: "clickable-logo",
    LOGO_EDIT_DIALOG_CONTENT: "logo-edit-dialog-content",
    LOGO_EDIT_DIALOG_FILE_INPUT: "logo-edit-dialog-file-input",
    LOGO_EDIT_DIALOG_UPLOAD_BUTTON: "logo-edit-dialog-upload-button",
    LOGO_EDIT_DIALOG_CANCEL_BUTTON: "logo-edit-dialog-cancel-button",
    LOGO_EDIT_DIALOG_ERROR_MESSAGE: "logo-edit-dialog-error-message",
    MERCHANT_NAME: "merchant-name",
    MERCHANT_DESCRIPTION_INPUT: "merchant-description-input",
    TAX_ID_INPUT: "tax-id-input",
    PHONE_INPUT: "phone-input",
    MOBILE_INPUT: "mobile-input",
    STEET_INPUT: "street-input",
    MERCHANT_ADDRESS_LINE_2_INPUT: "merchant-address-line-2-input",
    CITY_INPUT: "city-input",
    STATE_INPUT: "state-input",
    ZIP_CODE_INPUT: "zip-code-input",
    MERCHANT_NAME_INPUT: "merchant-name-input",
    EMAIL_INPUT: "email-input",
    WEBSITE_INPUT: "website-input",
    FACEBOOK_INPUT: "facebook-input",
    INSTAGRAM_INPUT: "instagram-input",
    LINKEDIN_INPUT: "linkedin-input",
    PINTEREST_INPUT: "pinterest-input",
    SAVE_BUTTON: "save-button",
    SUCCESS_MERCHANT_UPDATE: "success-merchant-update",
    ERROR_MERCHANT_UPDATE: "error-merchant-update",
    ERROR_MESSAGE_BAR: "error-message-bar",
    MORE_MENU: "more-menu",
    MORE_MENU_SET_INACTIVE: "more-menu-set-inactive",
    MORE_MENU_SET_ACTIVE: "more-menu-set-active",
    MERCHANT_DEACTIVATED_MESSAGE_BAR: "merchant-deactivated-message-bar",
};
